import { tv } from 'tailwind-variants';

export const nav = tv({
  base: 'border-gray-150 mt-1 border-y',
});

export const innerContainer = tv({
  base: 'flex h-14 items-center px-4',
});

export const arrowButton = tv({
  base: [
    'font-medium min-h-8 min-w-6 hover:underline focus-visible:ring-1 focus-visible:ring-black disabled:pointer-events-none lg:min-w-8 text-black text-xs gap-1 uppercase',
    'aria-disabled:opacity-100 aria-disabled:text-beige-4',
  ],
});

export const pageRange = tv({
  base: 'font-base text-gray-600 flex h-full grow items-center justify-center overflow-x-auto uppercase',
});

export const digits = tv({
  base: [
    'aria-disabled:text-beige-4 aria-disabled:opacity-100',
    'min-h-8 min-w-6 hover:underline focus-visible:ring-1 focus-visible:ring-black disabled:pointer-events-none',
  ],
});

export const lastDigit = tv({
  base: 'h-8 hover:underline',
});

export const ellipsis = tv({
  base: 'h-8 w-8 text-center leading-[2rem]',
});

export const paginationArrowButtons = tv({
  base: 'flex',
  variants: {
    layout: {
      forward: 'flex-row-reverse',
      backward: 'flex-row',
    },
  },
  defaultVariants: {
    layout: 'forward',
  },
});

export const paginationIconTextButton = tv({
  base: 'flex gap-0.5 items-center',
  variants: {
    layout: {
      forward: 'flex-row-reverse',
      backward: 'flex-row',
    },
  },
  defaultVariants: {
    layout: 'forward',
  },
});
